import CragModel from './crag_model';
import { Observable, ObservableSetter } from 'capo-mvvm';
import { LineModel } from './line_model';
import { BoulderModel } from './boulder_model';
import { Grade } from './grade';

export class Application {
    #crag: ObservableSetter<CragModel | null>;
    #boulder: ObservableSetter<BoulderModel | null>;
    #line: ObservableSetter<LineModel | null>;

    maxGrade : Grade = new Grade('8A');

    constructor() {
        this.#crag = new ObservableSetter<CragModel | null>(null);
        this.#boulder = new ObservableSetter<BoulderModel | null>(null);
        this.#line = new ObservableSetter<LineModel | null>(null);
    }

    set crag(newCrag: CragModel | null) {
        if (this.#crag.value != newCrag) {
            this.#boulder.value = null;
            this.#line.value = null;
            this.#crag.value = newCrag;
        }
    }

    get crag(): Observable<CragModel | null> {
        return this.#crag;
    }

    set boulder(newBoulder: BoulderModel | null) {
        if (this.#boulder.value != newBoulder) {
            this.#line.value = null;
            this.#boulder.value = newBoulder;
        }
    }
    
    get boulder(): Observable<BoulderModel | null> {
        return this.#boulder;
    }

    set line(newLine: LineModel) {
        this.#line.value = newLine;
        if (newLine.boulder != this.#boulder.value) {
            this.#boulder.value = newLine.boulder;
        }
    }

    get line(): Observable<LineModel | null> {
        return this.#line;
    }
};

let app: Application = new Application();

export function getApplicationInstance() {
    return app;
}

